<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.network.steam.step2.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col
        cols="6"
        class="yPadding"
      >
        <VSelect
          v-model="data.mettalurgyInCondensateSystem"
          :label="$t('technicalFile.network.steam.step2.mettalurgyInCondensateSystem')"
          :items="displayedUnits('mettalurgyInCondensateSystem')"
          type="number"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :disabled="readonly"
          flat
          hideDetails
          data-cy="mettalurgyInCondensateSystem"
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="6"
        class="yPadding"
      >
        <VTextField
          v-model="data.mettalurgyInCondensateSystemOther"
          :label="$t('technicalFile.network.steam.step2.mettalurgyInCondensateSystemOther')"
          :disabled="!isOtherOption('mettalurgyInCondensateSystem') || readonly"
          class="text-field-transparent"
          outlined
          flat
          hideDetails
          data-cy="mettalurgyInCondensateSystemOther"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Condense',
    props: {
        condense: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        condense: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.condense) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { condense: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
        isOtherOption(field) {
            return this.data[field] === -1;
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.yPadding {
  padding: 5px 0 5px 10px;
}

@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
